<ng-container [ngTemplateOutlet]="searchInputTemplate"></ng-container>

<oiq-ui-dropdown
  #dropdownRef="OiqUiDropdown"
  backdropClass="oiq-layout-search-backdrop"
  panelClass="oiq-layout-search-portal"
  [overlayPositions]="[
    {
      originX: 'start',
      originY: 'center',
      overlayX: 'end',
      overlayY: 'center'
    }
  ]">
  <button
    mat-icon-button
    id="search-icon"
    class="header-icon oiq-layout-search-icon"
    #searchIconRef
    (click)="dropdownRef.toggle()">
    <mat-icon>search</mat-icon>
  </button>
  <ng-template #dropdownTemplate>
    <ng-container [ngTemplateOutlet]="searchInputTemplate"></ng-container>
  </ng-template>
</oiq-ui-dropdown>

<ng-template #searchInputTemplate>
  <div class="oiq-layout-search-input">
    <mat-icon matPrefix>search</mat-icon>
    <input
      #inputFieldRef
      type="text"
      placeholder="Search"
      (input)="searchSubject$.next(inputFieldRef.value)" />
    <button
      mat-icon-button
      matSuffix
      class="clear-btn"
      *ngIf="inputFieldRef.value"
      (click)="inputFieldRef.value = ''"
      [class.visible]="inputFieldRef.value"
      aria-label="Clear">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</ng-template>
